const WELCOME = 'welcome back'
const DESCRIPTION = 'welcome back'
const EMAIL_LABEL = 'welcome back'
const PASSWORD_LABEL = 'welcome back'
const FORGOT_PASSWORD = 'forgot password ? '
const PASSWORD_BUTTON = 'login'
const OTP_BUTTON = 'login with otp'
const ADD_COURSE_TITLE = 'Add Course'
const BRANCH_INFORMATION = 'Branch Information'
const FORM_DESCRIPTION = 'Please make sure fill the filled before click on the next button'
const USER_DETAILS = 'User Details'
const FACULTY_INFORMATION = 'Faculty Information'
const FACULTY_DESCRIPTION = 'Please make sure fill the filled before click on the next button'
const FACULTY_BILLING_INFORMATION = 'Billing Information'
const FACULTY_BANK_INFORMATION = 'Bank Information'
const NEW_ENROLLMENT = 'New Enrollment'
const PERSONAL_INFORMATION = 'Personal information'
const PAGE_DESCRIPTION = 'Please make sure fill the filled before click on the next button'
const ACADEMIC_DETAILS = 'Academic Details'
const WORK_EXPERIENCE = 'Work Experience'
const COURSE_DETAILS = 'Course Details'
const FEES_STRUCTURE = 'Fees Structure'
const FEES_COLLECTION = 'Fees Collection'
const INQUIRY = 'Inquiry'
const INQUIRY_FORM_MSG = 'Please Make sure fill all the filed before click on next button'
const FOLLOWUP_PLANNING = 'Follow-Up and Planning'
const EDUCATION_BACKGROUND = 'Educational Background'
const INQUIRY_DETAILS = 'Inquiry Details'
const COURSE_INFORMATION = 'Course Information'
const CHARACTER_COUNT = '150 Character'
const ENROLL_MATERIALS = 'Enroll Materials'
const ENROLL_MATERIALS_DESCRIPTION = 'Click on items you want to add to this course...'
const MODULES_TITLE = 'Modules'
const COURSE_PRICING = 'Course Pricing'

const UI_TEXT = {
  LOGIN_PAGE: {
    WELCOME,
    DESCRIPTION,
    EMAIL_LABEL,
    PASSWORD_LABEL,
    FORGOT_PASSWORD,
    PASSWORD_BUTTON,
    OTP_BUTTON,
  },
  BRANCH_PAGE: {
    BRANCH_INFORMATION,
    FORM_DESCRIPTION,
    USER_DETAILS,
  },
  FACULTY_PAGE: {
    FACULTY_INFORMATION,
    FACULTY_DESCRIPTION,
    FACULTY_BILLING_INFORMATION,
    FACULTY_BANK_INFORMATION,
  },
  COURSE_PAGE: {
    ADD_COURSE_TITLE,
    COURSE_INFORMATION,
    FORM_DESCRIPTION,
    CHARACTER_COUNT,
    ENROLL_MATERIALS,
    ENROLL_MATERIALS_DESCRIPTION,
    MODULES_TITLE,
    COURSE_PRICING,
  },
  ENROLLMENT_PAGE: {
    NEW_ENROLLMENT,
    PERSONAL_INFORMATION,
    PAGE_DESCRIPTION,
    ACADEMIC_DETAILS,
    WORK_EXPERIENCE,
    COURSE_DETAILS,
    FEES_STRUCTURE,
    FEES_COLLECTION,
  },
  INQUIRY_PAGE: {
    INQUIRY,
    PERSONAL_INFORMATION,
    INQUIRY_FORM_MSG,
    FOLLOWUP_PLANNING,
    WORK_EXPERIENCE,
    EDUCATION_BACKGROUND,
    INQUIRY_DETAILS,
  },
}

export default UI_TEXT
